var ngModule;
try {
  ngModule = angular.module('templates');
} catch (e) {
  ngModule = angular.module('templates', []);
}

ngModule.run(['$templateCache', function ($templateCache) {
  $templateCache.put('/modals/mountain-route-form/mountain-route-form.html',
    '<div class="modal-body">\n' +
    '	<h2 class="margin_b_20">Добавить новый маршрут</h2>\n' +
    '	<form class="form ng-hide" name="mountainRouteForm" ng-submit="mountainRouteForm.$valid && routeForm.submit()" ng-show="!routeForm.progress">\n' +
    '		<form-widget field="routeForm.mountainRouteModel.$fields.slides"    ng-model="routeForm.mountainRoute.slides"></form-widget>\n' +
    '		<form-widget field="routeForm.mountainRouteModel.$fields.documents" ng-model="routeForm.mountainRoute.documents"></form-widget>\n' +
    '\n' +
    '		<fieldset class="form__fieldset width-350">\n' +
    '			<h3 class="page__title_xs">Название маршрута</h3>\n' +
    '			<form-row field="routeForm.mountainRouteModel.$fields.name" ng-model="routeForm.mountainRoute.name"></form-row>\n' +
    '			<div ng-if="mountainRouteForm.$submitted && mountainRouteForm.name.$error.required" class="form__error" role="alert">Обязательное поле</div>\n' +
    '		</fieldset>\n' +
    '\n' +
    '		<fieldset class="form__fieldset width-350">\n' +
    '			<h3 class="page__title_xs">Год прохождения</h3>\n' +
    '			<form-row field="routeForm.mountainRouteModel.$fields.first_ascent_year" ng-model="routeForm.mountainRoute.first_ascent_year"></form-row>\n' +
    '		</fieldset>\n' +
    '\n' +
    '		<fieldset class="form__fieldset width-350">\n' +
    '			<h3 class="page__title_xs">Вершина</h3>\n' +
    '			<div ng-repeat="mountain_peak in routeForm.mountainRoute.mountain_peaks" class="margin_b_20">\n' +
    '				<form-row field="routeForm.mountainRouteModel.$fields.mountain_peak" ng-model="mountain_peak" ng-model-options="{ index: $index }"></form-row>\n' +
    '				<span ng-click="routeForm.mountainRoute.mountain_peaks.splice($index,1)" ng-if="$index>0" class="btn-link profile-ascent__btn_delete">Удалить траверс</span>\n' +
    '			</div>\n' +
    '			<span ng-click="routeForm.mountainRoute.mountain_peaks.push({})" class="btn-link profile-ascent__btn_add margin_b_40">Добавить траверс</span>\n' +
    '		</fieldset>\n' +
    '\n' +
    '		<fieldset class="form__fieldset">\n' +
    '			<h3 class="page__title_xs">Характеристики маршрута</h3>\n' +
    '\n' +
    '			<div class="form-group_inline">\n' +
    '				<form-row field="routeForm.mountainRouteModel.$fields.routeType" ng-model="routeForm.mountainRoute.mountain_route_type"></form-row>\n' +
    '				<div ng-if="mountainRouteForm.$submitted && mountainRouteForm.routeType.$error.required" class="form__error" role="alert">Обязательное поле</div>\n' +
    '			</div>\n' +
    '\n' +
    '			<div class="form-group_inline">\n' +
    '				<form-row field="routeForm.mountainRouteModel.$fields.routeComplexity" ng-model="routeForm.mountainRoute.mountain_route_complexity"></form-row>\n' +
    '				<div ng-if="mountainRouteForm.$submitted && mountainRouteForm.routeComplexity.$error.required" class="form__error" role="alert">Обязательное поле</div>\n' +
    '			</div>\n' +
    '\n' +
    '			<div class="form-group_inline">\n' +
    '				<form-row field="routeForm.mountainRouteModel.$fields.routeUser" ng-model="routeForm.mountainRoute.user"></form-row>\n' +
    '				<div ng-if="mountainRouteForm.$submitted && mountainRouteForm.routeUser.$error.required" class="form__error" role="alert">Обязательное поле</div>\n' +
    '			</div>\n' +
    '		</fieldset>\n' +
    '\n' +
    '		<fieldset class="form__fieldset">\n' +
    '			<h3 class="page__title_xs">Описание маршрута</h3>\n' +
    '			<form-row field="routeForm.mountainRouteModel.$fields.description" ng-model="routeForm.mountainRoute.description"></form-row>\n' +
    '		</fieldset>\n' +
    '\n' +
    '		<fieldset class="form__fieldset margin_b_40">\n' +
    '			<h3 class="page__title_xs">Прикрепить файл</h3>\n' +
    '\n' +
    '			<ul class="form-list">\n' +
    '				<li class="form-list__item form-list__item_icon" ng-repeat="item in routeForm.documents_files" ng-class="{\'df-uploader__list-item--error\': item.isError}">\n' +
    '                    <span class="relative">\n' +
    '                        <a class="form-list__link" ng-if="item.isUploaded" ng-href="{{ routeForm.getDocumentUrl(item.serverData.id) }}" target="_blank">\n' +
    '							<span ng-bind="item.file.name"></span>\n' +
    '						</a>\n' +
    '                        <span class="form-list__item-close" ng-click="item.remove()"></span>\n' +
    '                        <p class="form__error_inline" ng-if="item.isError">Ошибка</p>\n' +
    '                    </span>\n' +
    '					<span class="" ng-if="item.isUploading"><i class="fa fa-spinner fa-pulse"></i></span>\n' +
    '				</li>\n' +
    '			</ul>\n' +
    '\n' +
    '			<form-row field="routeForm.mountainRouteModel.$fields.documentsFiles" ng-model="routeForm.documents_files" class="btn-file-upload"></form-row>\n' +
    '\n' +
    '		</fieldset>\n' +
    '		\n' +
    '		<div class="form__line"></div>\n' +
    '\n' +
    '		<div class="form-group">\n' +
    '			<button type="submit" class="btn-gold_big">Отправить описание</button>\n' +
    '		</div>\n' +
    '	</form>\n' +
    '</div>\n' +
    '<button class="close" ng-click="routeForm.close()"></button>');
}]);

module.exports = "/modals/mountain-route-form/mountain-route-form.html";